import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { api } from '@bayclubs/utils';
import { BcEmployeeAuthHttpParams } from '@bayclubs/employee-auth';

@Injectable()
export abstract class BaseHttpClient {

    abstract getUrl(): string;

    constructor(protected httpClient: HttpClient
    ) {
        this.httpClient = httpClient;
    }

    public get<T extends api.OperationResult>(url: string, showLoader: boolean = false, loadingContent: string = null): Observable<T> {
        let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', '*/*')
            .append('Cache-Control', 'no-cache')
            .append('Pragma', 'no-cache')
            .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');


        return this.httpClient.get<T>(this.getUrl() + url, {
            headers: headers,
            params: new BcEmployeeAuthHttpParams(showLoader, loadingContent, false)
        }).pipe(map((response: T) => {
            return response;
        }));
    }

    public post<T extends api.OperationResult>(url: string, data: any, showLoader: boolean = false, loadingContent: string = null): Observable<T> {
        let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', '*/*')
            .append('Cache-Control', 'no-cache')
            .append('Pragma', 'no-cache')
            .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');

        return this.httpClient.post<T>(this.getUrl() + url, data, {
            headers: headers,
            params: new BcEmployeeAuthHttpParams(showLoader, loadingContent, false)
        }).pipe(map((response: T) => {
            return response;
        }));
    }

    public delete<T extends api.OperationResult>(url: string, showLoader: boolean = false, loadingContent: string = null): Observable<T> {
        let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', '*/*')
            .append('Cache-Control', 'no-cache')
            .append('Pragma', 'no-cache')
            .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');


        return this.httpClient.delete<T>(this.getUrl() + url, {
            headers: headers,
            params: new BcEmployeeAuthHttpParams(showLoader, loadingContent, false)
        }).pipe(map((response: T) => {
            return response;
        }));
    }

    public postAsFormUrlEncoded(url: string, data: any): Observable<any> {
        const headers = new HttpHeaders()
            .append('Content-Type', 'application/x-www-form-urlencoded')
            .append('Accept', '*/*');

        return this.httpClient.post(this.getUrl() + url, data, {
            headers: headers
        }).pipe(map((response) => {
            return response;
        }));
    }


    public postFileRequest(url: string, data: any) {
        let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', '*/*');

        headers.append('responseType', '*/*');

        return this.httpClient.post(this.getUrl() + url, data, {
            headers: headers,
            responseType: 'blob'
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    public getFileRequest(url: string) {
        let headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Accept', '*/*');

        headers.append('responseType', '*/*');

        return this.httpClient.get(this.getUrl() + url, {
            headers: headers,
            responseType: 'blob'
        }).pipe(map((response: any) => {
            return response;
        }));
    }
}
